// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".safe-content[data-v-f0f92c8a] {\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
